import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * Signal component styles
 * @returns {Function}
 */

export const useStyles = makeStyles((theme) =>
  createStyles({
    signal: {
      display: 'flex',
      alignItems: 'center',
      background: variables.colorV2.personalizationToken.background,
      justifyContent: 'space-between',
      borderRadius: '0.4rem',
      width: '94% !important',
      padding: theme.spacing(1, 0.875, 1, 0.5),
    },
    leftContainer: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
    },
    content: {
      flex: 1,
      marginLeft: theme.spacing(0.5),
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    row: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    text: {
      color: variables.color.primary.darkestGray,
      fontFamily: variables.font.family.code,
      width: '20rem',
    },
    errorText: {
      color: variables.color.primary.red,
    },
    signalCapsule: {
      alignItems: 'center',
      backgroundColor: variables.colorV2.personalizationToken.background, // d8b5ff;
      border: '0 none',
      borderRadius: '2rem',
      color: variables.colorV2.personalizationToken.text,
      display: 'flex',
      height: '2.4rem',
      minHeight: '2.4rem',
      overflow: 'hidden',
      padding: '.3rem 0',
      width: 'fit-content !important',
    },
    signalText: {
      '&&': {
        color: variables.colorV2.personalizationToken.text,
        fontWeight: 400,
        margin: 'auto 0',
        overflow: 'hidden',
        padding: '0 1.5rem',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    },
  }),
);

export const useTooltipStyles = makeStyles((theme) =>
  createStyles({
    arrow: {
      color: variables.color.primary.halfMediumGray,
    },
    popper: {
      zIndex: 30000,
    },
    tooltip: {
      backgroundColor: variables.color.primary.white,
      boxShadow: theme.shadows[8],
    },
    tooltipArrow: {
      backgroundColor: variables.color.primary.white,
      border: `0.1rem solid ${variables.color.primary.halfMediumGray}`,
      color: variables.color.primary.mediumGray,
      fontSize: '1.1rem',
    },
    tooltipPlacementBottom: {
      margin: '4px 0 0 0',
    },
  }),
);
